















































import { Component, Vue, Watch } from 'vue-property-decorator'
import ArrowUpBoldBox from 'vue-material-design-icons/ArrowUpBoldBox.vue'
import ArrowExpandVertical from 'vue-material-design-icons/ArrowExpandVertical.vue'
import Blogs from '../static/blogs'
import { BlogInfo } from '@/types'

function markdownComponents() {
	return Blogs.reduce((acc: any, blog: BlogInfo) => {
		acc[blog.name] = () => import(`../markdowns/${blog.name}.md`)
		return acc
	}, {})
}

interface BlogStatus {
	[key: string]: boolean
}

@Component({
	components: {
		ArrowUpBoldBox,
		ArrowExpandVertical,
		...markdownComponents()
	}
})
export default class Blog extends Vue {
	private blogs: BlogInfo[] = Blogs
	private blogStatus: BlogStatus = {}
	private anyBlogOpen: boolean = false

	@Watch('$route', { immediate: true, deep: true })
	private onUrlChange() {
		this.updateBlogStatus()
	}

	private created(): void {
		this.updateBlogStatus()
	}

	private updateBlogStatus(): void {
		Vue.set(this, 'anyBlogOpen', false)

		this.blogs.forEach((blog: BlogInfo) => {
			if (blog.componentName === this.$router.currentRoute.meta.blogComponentName) {
				Vue.set(this, 'anyBlogOpen', true)
				Vue.set(this.blogStatus, `${blog.name}Open`, true)
			} else {
				Vue.set(this.blogStatus, `${blog.name}Open`, false)
			}
		})
	}
}
